var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM14.2774 7.98323C14.5719 7.69195 14.5745 7.21708 14.2832 6.92259C13.9919 6.62809 13.5171 6.62549 13.2226 6.91677L8.59375 11.4951L6.77741 9.69859C6.48292 9.4073 6.00805 9.40991 5.71677 9.7044C5.42549 9.9989 5.42809 10.4738 5.72259 10.765L8.06634 13.0832C8.35855 13.3723 8.82895 13.3723 9.12116 13.0832L14.2774 7.98323Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "fe661a0593b4f3a3293fa8db8939e86d.svg";
export { ForwardRef as ReactComponent };